import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const MyPathwayMilestoneRow = ({ milestone, details, titleClick, iconImage, insertEvent, isFirstRow = false }) => (
    <div className={'row collection-list-row'} key={milestone.permalink || milestone._id}>
        <div className={'row-icon col-1'}>
            {iconImage}
            <div className={'event-border'} />
        </div>
        <div className={`col-10 collection-info ${isFirstRow ? 'first-col-row' : ''}`}>
            <div className={'collection-list-row-details col-12'}>
                <div className={'collection-list-text'}>
                    <div className={'collection-list-row-name'}>
                        {insertEvent ? (
                            <div
                                onClick={titleClick}
                                className={`eventName ${milestone.urlLink ? 'link' : ''}`}
                                styles={{ cursor: milestone.urlLink ? 'pointer' : 'default' }}
                            >
                                <h3>{milestone.name}</h3>
                            </div>
                        ) : (
                            <Link to={`/collection/${milestone.permalink || milestone._id}`} onClick={titleClick}>
                                <h3 className={'collection-title-link'}>{milestone.name}</h3>
                            </Link>
                        )}
                    </div>
                    <div
                        className={`collection-list-row-subtitle ${
                            milestone.name && milestone.name.length <= 32 ? '' : 'short-subtitle'
                        }`}
                        styles={{ cursor: milestone.urlLink ? 'pointer' : 'default' }}
                    >
                        <p>{milestone.subtitle}</p>
                    </div>
                </div>
                <div className={'row collection-list-row-activities align-items-end'}>
                    {details.primaryDetail}
                    {details.secondaryDetail}
                    {details.dateTimeDetail}
                    {details.urlLinkDetail}
                    {details.taskCompleteDetail}
                </div>
            </div>
        </div>
    </div>
);

MyPathwayMilestoneRow.propTypes = {
    milestone: PropTypes.object,
    details: PropTypes.any,
    titleClick: PropTypes.func,
    iconImage: PropTypes.any,
    insertEvent: PropTypes.bool,
    isFirstRow: PropTypes.bool
};

export default MyPathwayMilestoneRow;
